import type { TourStep } from '../graph/schema-generated-types-educator';
import { TourIdKey } from '../types';

type tourDataArgs = {
  isEducator: boolean;
  tourId: number;
  userOrStudentId: number;
  tourSteps: TourStep[];
  isSingleStep: boolean;
  activeStepIndex?: number;
};

const formatAllStepsViewed = (tourSteps) => {
  if (!tourSteps?.length) return [];
  return tourSteps?.map((x) => ({ tourStepId: x?.id, viewed: true }));
};

const getSingleStepViewed = (tourSteps, activeStepIndex) => {
  const step = tourSteps?.[activeStepIndex];
  if (!step) return [];
  return [
    {
      tourStepId: step?.id,
      viewed: true,
    },
  ];
};

export const formatTourDataWithStepsViewed = (data: tourDataArgs) => {
  const { isEducator, tourId, userOrStudentId, tourSteps, isSingleStep, activeStepIndex } = data;
  const idKey = isEducator ? TourIdKey.USER_ID : TourIdKey.STUDENT_ID;
  const stepsAsViewed = isSingleStep
    ? getSingleStepViewed(tourSteps, activeStepIndex)
    : formatAllStepsViewed(tourSteps);
  const tourSettingsData = {
    [idKey]: userOrStudentId,
    toursSettings: {
      tourId,
      tourStepSettings: stepsAsViewed,
    },
  };
  return tourSettingsData;
};
